import React, {useEffect} from 'react';
import {SubUser} from "../../../services/models/sub_user";
import Select, {components} from "react-select";
import {DropdownIndicator} from "../../shared/DropdownIndicator";
import {customStyles} from "../../shared/selectStyles";

interface UserSelectProps {
    users?: SubUser[];
    selected?: string | null;
    onUserChange?: (userId: string) => void;
    disabled?: boolean | null;
}

interface UserOption {
    value: string;
    label: string;
    fullLabel: string;
}

export const UserSelect: React.FC<UserSelectProps> = ({users, selected, onUserChange, disabled = false}) => {
    const isInitialMount = React.useRef(true);
    const userOptions: UserOption[] = React.useMemo(() => {
        if (!users || users.length === 0) {
            return [];
        }

        const options = users
            .map(user => {
                // Проверяем наличие полей _id или id
                const userId = user._id || user.id;
                if (!userId) {
                    console.error('User object does not have id or _id field:', user);
                    return null;
                }

                return {
                    value: userId,
                    label: user.sectors_name,
                    fullLabel: user.sectors_name
                };
            })
            .filter((option): option is UserOption => option !== null);
        return options;
    }, [users]);
    useEffect(() => {
        if (isInitialMount.current && userOptions.length > 0 && !selected && onUserChange) {
            onUserChange(userOptions[0].value);
        }
        isInitialMount.current = false;
    }, [userOptions, selected, onUserChange]);

    // Находим выбранный option
    const selectedOption = selected ? userOptions.find(opt => opt.value === selected) : null;

    return (
        <Select
            isMulti={false}
            classNamePrefix="select"
            name="subUsers"
            options={userOptions}
            isSearchable={false}
            isClearable={false}
            isDisabled={disabled || false}
            placeholder={"Выберите пользователя"}
            noOptionsMessage={() => "Нет доступных опций"}
            components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
                Option: components.Option
            }}
            hideSelectedOptions={false}
            closeMenuOnSelect={true}
            blurInputOnSelect={true}
            value={selectedOption || userOptions[0]}
            onChange={(newValue) => {
                if (onUserChange && newValue) {
                    onUserChange((newValue as UserOption).value);
                }
            }}
            formatOptionLabel={({label, fullLabel}, {context}) => (
                <div title={fullLabel}>
                    {context === 'value' ? label : fullLabel}
                </div>
            )}
            styles={customStyles}
        />
    )
};